import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import {
  pendingToBeClaimListFxn
} from '../actions'
import { Button, Col, Row, Select } from 'antd'
import { listAllUniversities } from '../../university/actions/university'
import { listAllCountries } from '../../countries/actions/countries'
import { getBranchManagerAgentList } from '../../users/actions/user'
import { getUrlPushWrapper } from '../../../routes/routes'
import PendingStudentApplicationListDrawer from '../drawers/pendingStudentApplicationListDrawer'
import { filterOption, countryIds } from '../../../components/_utils/appUtils'

let initFilter = {
  countryId: countryIds.uk,
  status: '',
  universityId: '',
  intake: '',
  countryList: [],
  universityList: []
}
let claimRecInit = {
  visible: false,
  record: [],
  commissionCurrency: '',
  universityId: '',
  countryId: ''
}
const { Option } = Select
const PendingStudentCommission = (props) => {
  let [totalRecord, setTotalRecord] = useState(0)
  const [commissions, setCommissions] = useState([])
  const [filterState, setFilterState] = useState(initFilter)
  const [claimRecState, setClaimRecState] = useState(claimRecInit)
  const dispatch = useDispatch()
  const events = {

    showClaimRecDrawer: (record, currency, universityId, countryId) => {
      setClaimRecState({
        visible: true,
        record: record,
        commissionCurrency: currency,
        universityId: universityId,
        countryId: countryId
      })
    },
    hideClaimRecDrawer: () => {
      setClaimRecState({
        visible: false,
        record: [],
        commissionCurrency: '',
        universityId: '',
        countryId: ''
      })
      setTimeout(() => {
        fetchData()
      }, 100)
    },

    updateLocalFilter: (data) => {
      try {
        setFilterState({
          ...filterState,
          ...data
        })
      } catch (e) {
      }
    },
    getParamsObj: () => {
      return new Promise((resolve) => {
        let obj = {}
        let {
          countryId,
          universityId
        } = filterState
        if (countryId) {
          obj.countryId = countryId
        }
        if (universityId) {
          obj.universityId = universityId
        }
        resolve(obj)
      })
    },
    searchFxn: async () => {
      let obj = await events.getParamsObj()
      dispatch(
        getUrlPushWrapper('commissionPortal.PendingStudentCommission', {
          ...obj
        }))
      setTimeout(() => {
        fetchData()
      }, 100)
    },
    clearFxn: async () => {
      let obj = {}
      events.updateLocalFilter({
        universityId: ''
      })
      dispatch(
        getUrlPushWrapper('commissionPortal.PendingStudentCommission', {
          ...obj
        }))
      setTimeout(() => {
        fetchData()
      }, 100)
    }
  }
  useEffect(() => {
    loadData.loadCountryList()
    if (filterState.countryId) {
      loadData.loadUniversityNameList(filterState.countryId)
    }
  }, [])

  const loadData = {
    loadCountryList: async () => {
      let params = {
        results: 5000,
        select: ['countryName'],
        sortField: 'countryName',
        sortOrder: 'ascend'
      }
      let { data } = await dispatch(listAllCountries(params))
      let obj = {}
      if (data && data.length) {
        obj.countryList = data
      }
      events.updateLocalFilter({ ...obj })
    },
    loadUniversityNameList: async (countryId) => {
      let params = {
        results: 5000,
        select: ['universityName'],
        sortField: 'universityName',
        sortOrder: 'ascend',
        regExFilters: ['universityName'],
        showUniversity: [true, false],
        universityCountry: countryId
      }
      let { data } = await dispatch(listAllUniversities(params))
      let obj = {
        universityId: ''
      }
      if (data && data.length) {
        obj.universityList = data
      }
      events.updateLocalFilter({ ...obj, countryId })
    },
    loadAgents: async () => {
      let { data } = await dispatch(getBranchManagerAgentList())
      if (data && data.length) {
      }
    }
  }
  const fetchData = async () => {
    let resp = await events.getParamsObj()
    let respData = await dispatch(pendingToBeClaimListFxn(resp))
    if (respData.success) {
      setCommissions(respData.data)
      setTotalRecord(respData.totalClaimedCount)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const FilterComponent = (
    <div className={'filter_box'}>
      <Row gutter={16}>
        <Col md={4} sm={4} xs={8} lg={4}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select
              name='Search By University'
              onChange={(item) => {
                events.updateLocalFilter({ universityId: item })
              }}
              filterOption={filterOption}
              allowClear={true}
              showSearch={true}
              placeholder='University'
              value={filterState.universityId || undefined}
            >
              {filterState.universityList.map((item, key) => (
                <Option value={item._id} key={key}>{item.universityName}</Option>
              ))}
            </Select>
          </div>
        </Col>

        <Col md={6} sm={6} xs={8} lg={6}>
          <Button onClick={() => events.searchFxn()} className='roundBtn'>Search</Button>
          <Button onClick={() => events.clearFxn()} className='roundBtn'>Clear</Button>
        </Col>

        <Col md={{ span: 4, offset: 10 }} sm={4} xs={8} lg={{ span: 4, offset: 10 }}>
          <div className='sort-box-table custom-sort-box-new'>
            <Select
              name='Search By Country'
              onChange={(item) => {
                loadData.loadUniversityNameList(item)
              }}
              filterOption={filterOption}
              placeholder='Country'
              allowClear={false}
              showSearch={false}
              value={filterState.countryId || undefined}
            >
              {filterState.countryList.map((item, key) => (
                <Option value={item._id} key={key}>{item.countryName}</Option>
              ))}
            </Select>
          </div>
        </Col>
      </Row>

    </div>
  )
  return (
    <>

      <div className='col-lg-12'>
        <div className='card'>
          <div className='table-head d-flex align-items-center'>
            <h4>Pending Student Commission: ({totalRecord || 0})</h4>
          </div>
          <div className='card-body table-responsive'>
            {FilterComponent}
            {commissions.length > 0 && (
              <>
                <div className='card-pane-new listing-section w-100 direct-uni-box mt-4'
                     style={{ border: 'none' }}>
                  <ul className={'count flex-wrap'}>
                    {commissions.map((item, index) => (
                      <>
                        <li className={'canadaDirectUniCount canadaDirectUniBox'} key={index}>
                          <div className='innerBox' onClick={() => {
                            events.showClaimRecDrawer(item, item.currency, item.universityId, item.countryId)
                          }}>

                            <div className={'commission_list_grid'}>
                              <img src={item.universityLogo}
                                   alt='University Logo'
                                   className='rounded-circle'
                              />
                              <div className='university-name'>
                                {item && item.universityName}
                              </div>
                              <div className={'count'}>
                                {item.studentCount}
                              </div>
                            </div>

                          </div>
                        </li>
                      </>
                    ))
                    }
                  </ul>

                </div>
              </>
            )}

          </div>
        </div>
      </div>
      {claimRecState.visible ?
        <PendingStudentApplicationListDrawer
          visible={claimRecState.visible}
          onClose={events.hideClaimRecDrawer}
          records={claimRecState.record}
          commissionCurrency={claimRecState.commissionCurrency}
          universityId={claimRecState.universityId}
          countryId={claimRecState.countryId}
        /> : null}


    </>


  )
}

const mapStateToProps = ({ global, router }) => ({
  currentUser: global.currentUser
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingStudentCommission)
